import React, { memo } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RouteOnMount } from 'utils/routes';
import EmailEditor from './marketing/EmailEditor';
import MarketingCampaigns from './marketing';

const MarketingCampaignsContainer = memo(() => {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <RouteOnMount title="page_title_marketing_campaigns" onMount={() => {}} />
                    }
                />
                <Route
                    path="/email-editor"
                    element={<RouteOnMount title="page_title_email_editor" onMount={() => {}} />}
                />
            </Routes>
            <Routes>
                <Route path="/" element={<MarketingCampaigns />} />
                <Route path="/email-editor" element={<EmailEditor />} />
            </Routes>
        </>
    );
});

export default MarketingCampaignsContainer;
